import { IsInt, IsNotEmpty, IsString, MaxLength } from 'class-validator';

export class RegisterSurfboardTerminalDto {
  @IsNotEmpty()
  @IsInt()
  merchantId: number;

  @IsNotEmpty()
  @IsInt()
  posDeviceId: number;

  @IsNotEmpty()
  @IsString()
  @MaxLength(100)
  terminalRegistrationId: string;
}